<template>
  <div class="MainFrame" style="height: 100%">
    <div class="top" v-show="showTop">
      <el-affix position="top">
<!--        <el-row style="background-color: #0773DF;height: 50px; width: 100%;">-->
        <el-row style="background-color: #FFF;height: 75px; width: 100%;">
          <el-container>
            <el-aside width="380px">
              <el-col style="width: 380px;margin-top: 10px;float: left;display: inline">
                <div style="display: inline">
                  <el-image src="/logo.png" style="width: 290px;height: 55px;margin-left: 24px"></el-image>
                </div>
<!--                <div style="display: inline;position: relative;top: -10px">-->
<!--                  <el-button type="text" @click="$router.push({path:'/home/1-8'})"><h2 style="display: inline;margin-top:-10px;margin-left: 8px;text-align:left;font-weight: bold;font-family: HarmonyOS_Sans_SC_Regular;font-size: 18px;color: #FFFFFF" >综合治理成果管理平台</h2></el-button>-->
<!--                </div>-->
              </el-col>
            </el-aside>
<!--            <el-main width="300px">-->
            <el-main>
<!--              <el-menu-->
<!--                    :default-active="activeIndex"-->
<!--                    class="el-menu-demo"-->
<!--                    mode="horizontal"-->
<!--                    background-color="#0773df"-->
<!--                    text-color="#fff"-->
<!--                    active-text-color="#fff"-->
<!--                    menu-trigger="hover"-->
<!--                >-->
<!--                <el-menu-item  v-for="naviData1 in navigationData" :key="naviData1.idx" :index=naviData1.idx @click="navigateSelect" style="height: 50px;line-height: 50px;">-->
<!--                  <i :class="naviData1.iconName" style="color: #FFFFFF"></i>-->
<!--                  {{ naviData1.name }}-->
<!--                </el-menu-item>-->
<!--&lt;!&ndash;                  <el-submenu v-for="naviData1 in navigationData" :key="naviData1.idx" :index=naviData1.idx @click="navigateSelect">&ndash;&gt;-->
<!--&lt;!&ndash;                    <template #title>&ndash;&gt;-->
<!--&lt;!&ndash;                      <i :class="naviData1.iconName" style="color: white"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      <span>{{ naviData1.name }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                    </template>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div v-for="naviData in naviData1.children" :key="naviData.idx">&ndash;&gt;-->
<!--&lt;!&ndash;                      <el-menu-item v-if="naviData.isLeaf" :index="naviData.idx" :disabled="naviData.templateSize<=0">&ndash;&gt;-->
<!--&lt;!&ndash;                        <i :class="naviData.iconName" style="color: #FFFFFF"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                        {{ naviData.name }}&ndash;&gt;-->
<!--&lt;!&ndash;                      </el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                      <el-submenu v-if="!naviData.isLeaf" :index=naviData.idx >&ndash;&gt;-->
<!--&lt;!&ndash;                        <template #title>&ndash;&gt;-->
<!--&lt;!&ndash;                          <i :class="naviData.iconName" style="color: #FFFFFF"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                          <span>{{ naviData.name }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </template>&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash;            <el-scrollbar :height="naviData.children.length>6?300:(naviData.children[0].isLeaf?naviData.children.length*50:'100%')">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                        <div v-for="childData in naviData.children" :key="childData.idx">&ndash;&gt;-->
<!--&lt;!&ndash;                          <el-menu-item v-if="childData.isLeaf" :index="childData.idx" :class="childData.iconName" :disabled="childData.templateSize<=0">&ndash;&gt;-->
<!--&lt;!&ndash;                            {{ childData.name }}&ndash;&gt;-->
<!--&lt;!&ndash;                          </el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                          <el-submenu v-if="!childData.isLeaf" :index="childData.idx">&ndash;&gt;-->
<!--&lt;!&ndash;                            <template #title>&ndash;&gt;-->
<!--&lt;!&ndash;                              <i :class="childData.iconName" style="color: #FFFFFF"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                              <span>{{ childData.name }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                            </template>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div v-for="grandChild in childData.children" :key="grandChild.idx">&ndash;&gt;-->
<!--&lt;!&ndash;                              <el-menu-item v-if="grandChild.isLeaf"&ndash;&gt;-->
<!--&lt;!&ndash;                                            :index="grandChild.idx"&ndash;&gt;-->
<!--&lt;!&ndash;                                            :class="grandChild.iconName" :disabled="grandChild.templateSize<=0">&ndash;&gt;-->
<!--&lt;!&ndash;                                {{ grandChild.name }}&ndash;&gt;-->
<!--&lt;!&ndash;                              </el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                              <el-menu-item-group v-if="!grandChild.isLeaf">&ndash;&gt;-->
<!--&lt;!&ndash;                                <template #title>-&#45;&#45;{{ grandChild.name }}-&#45;&#45;</template>&ndash;&gt;-->
<!--&lt;!&ndash;                                <el-menu-item v-for="levData in grandChild.children" :key="levData.idx" :index="levData.idx"&ndash;&gt;-->
<!--&lt;!&ndash;                                              :class="levData.iconName" :disabled="levData.templateSize<=0">&ndash;&gt;-->
<!--&lt;!&ndash;                                  {{ levData.name }}&ndash;&gt;-->
<!--&lt;!&ndash;                                </el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                              </el-menu-item-group>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          </el-submenu>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash;            </el-scrollbar>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                      </el-submenu>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </el-submenu>&ndash;&gt;-->
<!--                </el-menu>-->
            </el-main>
            <el-aside width="400px">
              <el-col style="width:240px;float:right;color: #2f76c2" >
                <div style="height: 50px;line-height: 75px;overflow:hidden;margin-right: 20px;">
                  {{currentDateTime}}
                </div>
              </el-col>
              <el-col style="width:160px;float:right;color: #2f76c2" >
                <div style="height: 50px;line-height: 75px;overflow:hidden;margin-right: 20px;">
<!--                  导航:-->
<!--                  <el-switch v-model="value" style="margin:0px 15px 0px 0px;" @change="changeStatus">-->
<!--                  </el-switch>-->
<!--                  统计信息:-->
<!--                  <el-switch v-model="tjshowValue" style="margin:0px 15px 0px 0px;" @change="setRightCollapse">-->
<!--                  </el-switch>-->
                  <i class="el-icon-user-solid" style="color: #2f76c2"/> <span>欢迎您：</span>
                  <el-dropdown>
                    <span class="el-dropdown-link" style="color: #000000">
                      {{ userName}}
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu>
<!--                        <el-dropdown-item @click="openFeedLog" icon="el-icon-s-order">反馈记录</el-dropdown-item>-->
                        <el-dropdown-item @click="logout" icon="el-icon-back">系统登出</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <!--<el-popover-->
                  <!--placement="bottom-start"-->
                  <!--title="预警信息"-->
                  <!--:width="200"-->
                  <!--trigger="hover"-->
                  <!--&gt;-->
                  <!--<el-scrollbar max-height="200px">-->
                  <!--<p v-for="item in messageList" :key="item">{{item}}</p>-->
                  <!--</el-scrollbar>-->
                  <!--<template #reference>-->
                  <!--<el-badge :value="12" class="item">-->
                  <!--<el-dropdown>-->
                  <!--<span class="el-dropdown-link">{{ userName }}</span>-->
                  <!--<template #dropdown>-->
                  <!--<el-dropdown-menu>-->
                  <!--<el-dropdown-item @click="logout" icon="el-icon-back">登出</el-dropdown-item>-->
                  <!--</el-dropdown-menu>-->
                  <!--</template>-->
                  <!--</el-dropdown>-->
                  <!--</el-badge>-->
                  <!--</template>-->
                  <!--</el-popover>-->

<!--                  <el-popover-->
<!--                      placement="bottom-start"-->
<!--                      :width="200"-->
<!--                      trigger="hover"-->
<!--                  >-->
<!--                    &lt;!&ndash;          content="1.DN2今日产油量异常 2.您有一条待审信息。"&ndash;&gt;-->
<!--                    &lt;!&ndash;      >&ndash;&gt;-->
<!--                    <template #default>-->
<!--                      <span>预警信息</span>-->
<!--                      <el-button style="float: right; margin-top: -10px" type="text" @click.stop="isReader(1,0)">全部已读</el-button>-->
<!--                      <el-divider />-->
<!--                      <el-scrollbar max-height="200px">-->
<!--                        <el-check-tag type="info" effect="plain" checked :underline="false" v-for="(item,index) in messageList" @click.stop="isReader(2,index)" :key="index">{{item.JH}}{{item.label}}{{item.message}}</el-check-tag>-->
<!--                      </el-scrollbar>-->
<!--                    </template>-->
<!--                    <template #reference>-->
<!--                      <el-badge-->
<!--                          :hidden="messageList.length<1"-->
<!--                          :value="messageList.length"-->
<!--                          class="item"-->
<!--                          type="warning"-->
<!--                          style="width: 15px"-->
<!--                          :max="10"-->
<!--                      >-->
<!--                        &lt;!&ndash;                  <el-button size="small">提示信息</el-button>&ndash;&gt;-->
<!--                      </el-badge>-->
<!--                    </template>-->
<!--                  </el-popover>-->
<!--                  <el-button :onclick="feedBack" type="text" style="color: #ffffff">反馈</el-button>-->
<!--                  <el-button :onclick="downloadWord" type="text" class="el-icon-question" style="color: #ffffff">帮助</el-button>-->
                </div>
              </el-col>
            </el-aside>
          </el-container>
        </el-row>
      </el-affix>
    </div>
    <div id="box" style="height: calc(100vh - 50px)">
      <div id="left" v-show="showLeft" v-bind:style="{ width: leftDetailWidth + 'px' }">
        <el-row>
          <el-tooltip
              effect="light"
              content="收起左侧边栏"
              placement="right"
          >
          <el-button :onclick="()=>{isLeftCollapse = !isLeftCollapse;setLeftCollapse(true)}" type="text" :class="leftCollapseBtnName" style="color: #333333"/>
          </el-tooltip>
        </el-row>
<!--        <el-row>-->
<!--          <el-tooltip-->
<!--              effect="light"-->
<!--              :content="isLeftShowFunc?'收起区块导航栏':'展开区块导航栏'"-->
<!--              placement="right"-->
<!--          >-->
<!--          <el-button :onclick="()=>{isLeftShowFunc=!isLeftShowFunc;setLeftCollapse(false)}" type="text" :class="isLeftShowFunc?'el-icon-s-promotion':'el-icon-position'" style="color: #333333"/>-->
<!--          </el-tooltip>-->
<!--        </el-row>-->
<!--        <el-row>-->
<!--          <el-tooltip-->
<!--              effect="light"-->
<!--              :content="isLeftShowWell?'收起井位栏':'展开井位栏'"-->
<!--              placement="right"-->
<!--          >-->
<!--            <el-button :onclick="()=>{isLeftShowWell=!isLeftShowWell;setLeftCollapse(false)}" type="text" :class="isLeftShowWell?'el-icon-location':'el-icon-location-outline'" style="color: #333333"/>-->
<!--          </el-tooltip>-->
<!--        </el-row>-->
      </div>
      <div id="leftresize" v-show="showLeft"></div>
      <div id="main">
        <el-container style="height: 100%">
          <el-aside v-show="showLeft" :width=leftWidth style="background-color: #fbfbfb;height: 110%">
            <NavigationView v-show="isLeftCollapse==false" :root-navigate-id="curNavigateId" :is-show-func="isLeftShowFunc" :is-show-well="isLeftShowWell"/>
          </el-aside>
          <el-main>
            <MainView :gis-status="gisStatus"/>
          </el-main>
          <el-aside v-show="showRight" :width=rightWidth style="background-color: #fbfbfb">
            <StatisticsInfo ref="StatisticsInfo" v-show="isRightCollapse==false" :root-navigate-id="curNavigateId"/>
          </el-aside>
        </el-container>
      </div>
    </div>
  </div>
  <!--  <el-affix position="bottom" :offset="10" align="right">-->
  <!--    <div>导航：-->
  <!--      &lt;!&ndash;      <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">&ndash;&gt;-->
  <!--      -->
  <!--    </div>-->
  <!--  </el-affix>-->
</template>

<script>
import StatisticsInfo from "@/views/frameviews/StatisticsInfo";
import MainView from '@/views/frameviews/MainView';
import NavigationView from "@/views/frameviews/NavigationView";
import axios from "axios";
import { ElMessage } from 'element-plus';
import FileSaver from "file-saver";
// import os from "os";
export default {
  name: "MainFrame",
  components: {
    StatisticsInfo,
    MainView,
    NavigationView
  },
  props: {
    msg: String
  },
  computed: {
    // 计算属性 - 返回当前时间
    updateCurrentDateTime() {
      setInterval(() => {
        const time = new Date();
        if(time.getMinutes()<10){
          this.currentDateTime = `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日 ${time.getHours()}:0${time.getMinutes()}`;
        }
        else {
          this.currentDateTime = `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日 ${time.getHours()}:${time.getMinutes()}`;
        }
      }, 1000);
    }
  },
  data: function () {
    return {
      currentDateTime:"",
      showTop:true,
      showLeft:true,
      showRight:true,
      userIP:"0.0.0.0",
      leftDetailWidth: 20,
      rightDetailWidth: 30,
      value: false,
      tjshowValue: false,
      gisStatus: false,
      leftCollapseBtnName: "el-icon-caret-left",
      isLeftCollapse: false,
      isLeftShowWell: false,
      isLeftShowFunc: true,
      leftWidth: "224px",
      leftBtnStyle: "width: 224px;text-align: right",
      rightCollapseBtnName: "<<",
      isRightCollapse: true,
      rightWidth: "0px",
      rightBtnStyle: "width: 30px;text-align: left",
      // isRightCollapse: false,
      // rightCollapseBtnName: ">>",
      // rightWidth: "230px",
      // rightBtnStyle: "width: 230px;text-align: left",
      // activeIndex: "1-8",
      activeIndex: "1",
      navigationData: [],
      curNavigateId: "",
      userName: "",
      myWebSocket: null,
      messageList:[],
    }
  },
  mounted() {
    // this.dragControllerDiv();
    this.initWebSocket()
    this.updateCurrentDateTime;
    let _this = this;
    let yjcgMsgDat = localStorage.getItem("yjcgMsgData");
    console.log("msgDat",yjcgMsgDat)
    if(yjcgMsgDat !== null && yjcgMsgDat != undefined && yjcgMsgDat != 'null'){
      _this.showTop = false;
      _this.showLeft = false;
      _this.showRight = false;
    }
  },
  async created() {
    // let userInfoSession = localStorage.getItem("lyqtUserInfo");
    // if (userInfoSession == null) userInfoSession = {};
    let userInfoSession = localStorage.getItem("licUserINFO");
    if (!(userInfoSession === null || userInfoSession === undefined)) {
      userInfoSession = JSON.parse(userInfoSession);
      this.userName = userInfoSession.USER_NAME;
    }
    console.log(this.userName,userInfoSession)

    // console.log("uuuus:",userInfoSession);
    // if (userInfoSession.length > 0) {
    //   let jsonUserInfo = JSON.parse(userInfoSession);
    //   _this.userName = jsonUserInfo.displayName;
    // }
    this.fetchNavigateData();

    //记录登录信息
    let jwtSession = localStorage.getItem("lyqtJwt");
    if (jwtSession == null) jwtSession = "";
    await this.getNetworkIp();
    // axios({
    //   url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/addLoginLog",
    //   headers: {
    //     "Authorization": "Bearer " + jwtSession
    //   },
    //   data:{
    //     userIP:this.userIP,
    //     userMac:"mac"
    //   },
    //   method: 'POST',
    // }).then((res) => {
    //   if (res.status === 200) {
    //     console.log("验证通过");
    //   }
    // }).catch((err) => {
    //   // alert('Error');
    //   console.log(err)
    // })

    /* document.oncontextmenu = function(){return false};
     let _this =this;
     document.addEventListener('contextmenu',function(e){
       _this.openMenu(e)
     })*/
  },
  unmounted(){
    // console.log("离开路由关闭webSocket")
    //this.webSocket.close();//离开路由关闭webSocket
  },
  methods: {
    async getNetworkIp() {
      this.userIP = "0.0.0.0";
      if (process.env.NODE_ENV === "development"){
        this.userIP = localStorage.getItem("userLocalIP");
      }
      if(this.userIP == "0.0.0.0") {
        await axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getIpAddr")
            .then(res => {
              this.userIP = res.data;
              localStorage.removeItem("userLocalIP");
              localStorage.setItem("userLocalIP", this.userIP);
            }).catch(err => {
              console.log(err)
            })
        console.log("ip:", this.userIP)
      }
    },
    // dragControllerDiv: function() {
    //   // 保留this引用
    //   let data = this;
    //   let rightresize = document.getElementById("rightresize");
    //   rightresize.onmousedown = function(e) {
    //     // 颜色改变提醒
    //     rightresize.style.background = "#818181";
    //     let startX = e.clientX;
    //     rightresize.main = rightresize.offsetLeft;
    //     document.onmousemove = function(e) {
    //       // 计算并应用位移量
    //       let endX = e.clientX;
    //       let moveLen = endX - startX;
    //       startX = endX;
    //       data.rightDetailWidth -= moveLen;
    //     };
    //     document.onmouseup = function() {
    //       // 颜色恢复
    //       rightresize.style.background = "";
    //       document.onmousemove = null;
    //       document.onmouseup = null;
    //     };
    //     return false;
    //   };
    //   let leftresize = document.getElementById("leftresize");
    //   leftresize.onmousedown = function(e) {
    //     // 颜色改变提醒
    //     leftresize.style.background = "#818181";
    //     let startX = e.clientX;
    //     leftresize.main = leftresize.offsetLeft;
    //     document.onmousemove = function(e) {
    //       // 计算并应用位移量
    //       let endX = e.clientX;
    //       let moveLen = endX - startX;
    //       startX = endX;
    //       data.leftDetailWidth += moveLen;
    //     };
    //     document.onmouseup = function() {
    //       // 颜色恢复
    //       leftresize.style.background = "";
    //       document.onmousemove = null;
    //       document.onmouseup = null;
    //     };
    //     return false;
    //   };
    // },

    //webSocket初始化
    initWebSocket(){
      // if(typeof(WebSocket) != 'function'){
      //   ElMessage("您的浏览器版本过低,部分功能不支持")
      //   return
      // }
      // this.myWebSocket = new WebSocket(process.env.VUE_APP_WSSERVER +"/dataprovider/businessdata/websocket");
      //
      // this.myWebSocket.onopen = this.wsOpen;
      // this.myWebSocket.onmessage = this.wsMessage;
      // this.myWebSocket.onerror = this.wsError;
    },
    wsOpen(){
      console.log("连接成功")
      if(JSON.parse(localStorage.getItem('messageList')) == null){
        return
      }
      if(JSON.parse(localStorage.getItem('messageList')).length!=0){
        this.messageList = JSON.parse(localStorage.getItem('messageList'))
      }
    },
    wsMessage(e){
      let arr = null;
      try{
        arr = JSON.parse(e.data);
      }catch{
        return
      }
      console.log("服务器返回的玩意",arr)
      if(arr[0].JH == undefined){
        return
      }
      if(e.data.length>10){
        this.messageList = [];
        if(this.messageList.length == 0){
          arr.forEach(item => {
            //let str =`${item.JH}的${item.label}为${item.message}`;
            this.messageList.push(item);
          })
        }else{
          for(let i in arr){
            for(let j in this.messageList){
              if(arr[i].JH == this.messageList[j].JH && arr[i].data == this.messageList[j].data && arr[i].value == this.messageList[j].value){
                arr[i].push = false;
              }
            }
          }
          console.log(arr)
          arr.forEach(item=>{
            //let str =`${item.JH}的${item.label}为${item.message}`;
            if(item.push != false){
              this.messageList.push(item);
            }
          })
        }
      }
      localStorage.setItem('messageList',JSON.stringify(this.messageList))
    },
    wsError(e){
      console.log(e)
      localStorage.setItem('messageList','[]')
    },
    isReader(type,e){
      let arr = [];
      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/warning/addMsg";
      // let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/warning/addMsg?AppID=54e8099c-4202-485f-9503-13bd0dce5f53&AppSercect=4mjp5emfes3g6xxuxd4nulux";
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      if(type == 2){
        let params = {};
        params.columnCode = this.messageList[e].JH;
        params.compareDate = this.messageList[e].compareDate;
        params.data = this.messageList[e].data;
        params.dataSource = this.messageList[e].dataSource;
        params.isRead = 1;
        params.label = this.messageList[e].label;
        params.scheme = this.messageList[e].scheme;
        params.value = this.messageList[e].value;
        arr[0] = params;
      }
      if(type == 1){
        for(let i in this.messageList){
          let params = {};
          params.columnCode = this.messageList[i].JH;
          params.compareDate = this.messageList[i].compareDate;
          params.data = this.messageList[i].data;
          params.dataSource = this.messageList[i].dataSource;
          params.isRead = 1;
          params.label = this.messageList[i].label;
          params.scheme = this.messageList[i].scheme;
          params.value = this.messageList[i].value;
          arr.push(params)
        }
      }
      console.log(arr)
      axios.post(url,arr,{
        headers:{"Authorization": "Bearer " + token},
      }).then(res=>{
        console.log(res)
        if(type == 2){
          this.$store.state.isWarDriing = 1;
          this.$store.state.warningReadData = this.messageList[e];
          this.messageList.splice(e,1)
          localStorage.setItem('messageList',JSON.stringify(this.messageList))
          this.$store.state.warningList = this.messageList;
          if(this.$route.name != res.data.data[0].routername){
            this.$router.push({path:'/home/'+res.data.data[0].routername});
          }
        }
        if(type == 1){
          this.messageList=[];
          localStorage.setItem('messageList','[]')
        }
      })

    },
    fetchNavigateData(){
      let that = this;
      // let strpid = 'root';
      let strmode = 'pidmode';
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      let strnavigateUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/mainNavigateData";
      // if (strpid.length > 0 && strmode.length > 0)
      //   strnavigateUrl += "?pid=" + strpid + "&mode=" + strmode;
      axios({
        url: strnavigateUrl,
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET'
      }).then((res) => {
        if (res.status === 200) {
          that.navigationData = res.data;
          if (that.navigationData.length > 0) that.curNavigateId = that.navigationData[0];
          console.log("mainNavigate:",strmode,res);
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    openFeedLog(){
      let url = 'http://feedback-svc-wtfk.uat.tlmyt.petrochina/omsp/index.html#/dashboard';
      window.open(url)
    },
    //用户登出
    logout() {
      localStorage.removeItem("licUserJwt");
      localStorage.removeItem("licUserCode");
      this.$router.push({path:"/login"})
    },
    changeStatus(status) {
      this.gisStatus = status;
    },
    //左边栏显示隐藏
    setLeftCollapse(isLeftCollapse) {
      if(!isLeftCollapse) {
        if (!this.isLeftShowWell && !this.isLeftShowFunc) {
          this.isLeftCollapse = true;
        }
        if (this.isLeftShowWell || this.isLeftShowFunc) {
          this.isLeftCollapse = false;
        }
      }
      if(!this.isLeftCollapse&&!this.isLeftShowWell&&!this.isLeftShowFunc){
        this.isLeftShowFunc = true;
        this.isLeftShowWell = false;
      }
      this.$store.state.isLeftCollapse=this.isLeftCollapse;
      if (this.isLeftCollapse) {
        this.isLeftShowFunc = false;
        this.isLeftShowWell = false;
        this.leftWidth = "0px";
        this.leftCollapseBtnName = "el-icon-caret-right";
        this.leftBtnStyle = "width: 30px;text-align: right";
      } else {
        this.leftWidth = this.isLeftShowWell&&this.isLeftShowFunc?"400px":"224px";
        this.leftCollapseBtnName = "el-icon-caret-left";
        this.leftBtnStyle = "width: 224px;text-align: right";
      }
    },
    //右边栏显示隐藏
    setRightCollapse() {
      console.log("curNavig:",this.curNavigateId.idx,this.curNavigateId.idx>2);
      if(this.curNavigateId.idx>2){
        this.tjshowValue = false;
        this.isRightCollapse = true;
        ElMessage({type:"info",message:"该模块无统计信息！"});
      }
      else{
        this.isRightCollapse = !this.isRightCollapse;
      }

      this.$store.state.isRightCollapse=this.isRightCollapse;
      if (this.isRightCollapse) {
        this.rightWidth = "0px";
        this.rightCollapseBtnName = "<<";
        this.rightBtnStyle = "width: 30px;text-align: left";
      } else {
        this.rightWidth = "224px";
        this.rightCollapseBtnName = ">>";
        this.rightBtnStyle = "width: 224px;text-align: left";
      }
    },
    navigateSelect(key, keyPath) {
      console.log("click:",key, keyPath);
      let curIdx = key.index;
      // let curIdx = 1;
      // switch (key.target.innerText){
      //   case "基础数据综合应用":
      //     curIdx = 1;
      //     break;
      //   case "工作研究成果管理":
      //     curIdx = 2;
      //     break;
      //   case "综合治理方案管理":
      //     curIdx = 3;
      //     break;
      //   case "综合治理考核评估":
      //     curIdx = 4;
      //     break;
      //   case "系统设置":
      //     curIdx = 5;
      //     break;
      // }
      // console.log(this.navigationData.at(key-1));
      let _this = this;
      if (curIdx >= 0) _this.curNavigateId = _this.navigationData[curIdx - 1];
      if(this.tjshowValue && this.curNavigateId.idx>2) {
        this.setRightCollapse();
      }
    },
    //Navigation模块中勾选油田井数据传给Statiscsinfo模块
    statistics (checkedBlock){
      this.$refs.StatisticsInfo.doStatistics(checkedBlock);
    },
    feedBack(){
      let jwtSession = localStorage.getItem("lyqtJwt");
      let url = 'http://feedback-svc-wtfk.uat.tlmyt.petrochina/omsp/forward.html?appid=7cff6a1e-1270-4ab0-a8c6-f902b9491fb7_LQYTZHZLCG&url=IM_UOP_WORKORDER_REGISTER_ADD&jwt='+jwtSession;
      window.open(url)
    },
    //下载帮助文档
    downloadWord(){
      let PDFFile = 'http://lyqtgateway.uat.tlmyt.petrochina/fileprocesser/f/help_v1.docx'
      let PDFFileName = '《老油气田综合治理研究工作成果数据管理平台（二期）》帮助手册v1.docx'
      FileSaver.saveAs(PDFFile, PDFFileName)
    }
  }
};
</script>

<style scoped>
/deep/.el-main {
  padding:1px
}
#box {
  width: 100%;
  /*height: 400px;*/
  position: relative;
  overflow: hidden;
  display: flex;
}

.top {
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
}

#main {
  height: 100%;
  width: 200px;
  background: #ffffff;
  flex: 1;
  overflow-y: hidden;
}

#leftresize {
  width: 0px;
  height: 100%;
  cursor: w-resize;
}

#left {
  /*height: 100%;*/
  background: #fbfbfb;
  border-style: solid;
  border-width: 1px;
  border-color: #eeeeee;
  text-align: center;
}

/deep/.el-dropdown {
  color: #58aaff;
}
.el-dropdown-link {
  cursor: pointer;
  font-size: 16px;
  color: #e0e1e7;
  display: flex;
  align-items: center;
}
/deep/.el-menu--horizontal {
  display: flex;
  flex-wrap: nowrap;
}
/deep/.el-submenu__title i {
  color: unset;
}

/deep/.el-check-tag.is-checked {
  background-color: #FFFFFF;
  color: #53a8ff;
}
/deep/.el-check-tag.is-checked:hover {
  background-color: #fffacf;
  color: #EE0000;
}
/deep/.el-submenu__title {
  font-size: 16px;
  color: #303133;
  cursor: pointer;
  white-space: nowrap;
  /*font-family: "方正大黑简体";*/
}
/deep/.el-menu-item{
  font-size: 16px;
  color: #303133;
  cursor: pointer;
  white-space: nowrap;
  /*font-family: "方正大黑简体";*/
}
/*/deep/.el-submenu.is-active .el-submenu__title{*/
/*  background-color: #005288 !important;*/
/*  border-bottom-color: #005288 !important;*/
/*  color: #FFFFFF !important;*/
/*}*/
/deep/.el-menu--horizontal > .el-menu-item.is-active{
  background-color: #065CB2 !important;
  border-bottom-color: #065CB2 !important;
  color: #FFFFFF !important;
}

/deep/.el-dialog__header {
  padding: 20px 20px 10px;
  background-color: rgb(217,240,255);
}
</style>


<!--<template>-->


<!--  <el-row>-->
<!--    <el-col style="background-color: #EEEEEE;width: 30px" :span="1">-->
<!--      <el-row>-->
<!--      -->
<!--      </el-row>-->
<!--      <el-row>-->
<!--        asdf-->
<!--      </el-row>-->
<!--    </el-col>-->
<!--    <el-col :span="22">-->
<!--      -->
<!--    </el-col>-->
<!--    <el-col style="background-color: #EEEEEE;width: 30px" :span="1">-->
<!--      <el-button :onclick="setLeftCollapse" type="text" class="el-icon-caret-left" style="color: #333333"/>-->
<!--    </el-col>-->
<!--  </el-row>-->
<!--</template>-->

<!--<script>-->
<!--// import StatisticsInfo from "@/views/frameviews/StatisticsInfo";-->
<!--// import MainView from '@/views/frameviews/MainView';-->
<!--// import NavigationView from "@/views/frameviews/NavigationView";-->


<!--export default {-->
<!--  // name: '',-->
<!--  // components: {-->
<!--  //   StatisticsInfo,-->
<!--  //   MainView,-->
<!--  //   NavigationView-->
<!--  // },-->
<!--  // created() {-->
<!--  //   let _this = this;-->
<!--  //   let userInfoSession = localStorage.getItem("lyqtUserInfo");-->
<!--  //   if (userInfoSession == null) userInfoSession = {};-->
<!--  //   // console.log("uuuus:",userInfoSession);-->
<!--  //   if (userInfoSession.length > 0) {-->
<!--  //     let jsonUserInfo = JSON.parse(userInfoSession);-->
<!--  //     _this.userName = jsonUserInfo.displayName;-->
<!--  //   }-->
<!--  //   _this.fetchNavigateData();-->
<!--  //   /* document.oncontextmenu = function(){return false};-->
<!--  //    let _this =this;-->
<!--  //    document.addEventListener('contextmenu',function(e){-->
<!--  //      _this.openMenu(e)-->
<!--  //    })*/-->
<!--  // },-->
<!--  // data() {-->
<!--  //   return {-->
<!--  //     value: true,-->
<!--  //     gisStatus: false,-->
<!--  //     leftCollapseBtnName: "<<",-->
<!--  //     isLeftCollapse: false,-->
<!--  //     leftWidth: "230px",-->
<!--  //     leftBtnStyle: "width: 230px;text-align: right",-->
<!--  //     rightCollapseBtnName: ">>",-->
<!--  //     isRightCollapse: false,-->
<!--  //     rightWidth: "230px",-->
<!--  //     rightBtnStyle: "width: 230px;text-align: left",-->
<!--  //     activeIndex: 1,-->
<!--  //     navigationData: [],-->
<!--  //     curNavigateId: "",-->
<!--  //     userName: ""-->
<!--  //   }-->
<!--  // },-->
<!--  methods: {-->
<!--    -->
<!--  }-->
<!--}-->
<!--</script>-->
